import { DashboardOrderDetailsResponse } from "@/shared/api";
import { Flex } from "@radix-ui/themes";
import { createColumnHelper } from "@tanstack/react-table";
import { useState, useMemo } from "react";
import { DataTable } from "./data-table";
import { DialogTable } from "./dialog-table";

type ZoneBasedAnomalyProps = {
  data: DashboardOrderDetailsResponse["result"]["zone_based_anomaly"];
};

export function ZoneBasedAnomaly({ data }: ZoneBasedAnomalyProps) {
  const [columnHelper] = useState(() => createColumnHelper<any>());

  const columns = useMemo(() => {
    const trackIds = Object.keys(data.indicator_group_per_track_id);

    if (trackIds.length === 0) return [];

    const firstTrackId = trackIds[0];
    const firstTrackIdData = data.indicator_group_per_track_id[firstTrackId];
    const columnKeys = Object.keys(firstTrackIdData);

    columnKeys.unshift("track_id");

    return columnKeys.map((key) => {
      if (key === "track_anomaly_indicators")
        return columnHelper.accessor(key, {
          header: () => (
            <span className="capitalize">{key.split("_").join(" ")}</span>
          ),
          cell: ({ getValue }) => {
            return <DialogTable data={getValue()} />;
          },
        });

      return columnHelper.accessor(key, {
        header: () => (
          <span className="capitalize">{key.split("_").join(" ")}</span>
        ),
      });
    });
  }, [data, columnHelper]);

  const tableData = useMemo(() => {
    return Object.keys(data.indicator_group_per_track_id).map((trackId) => ({
      ...data.indicator_group_per_track_id[trackId],
      track_id: trackId,
    }));
  }, [data.indicator_group_per_track_id]);

  return (
    <Flex direction="column" className="h-[calc(100dvh-11rem)]">
      <DataTable
        loading={false}
        isSuccess={true}
        totalCount={tableData.length}
        data={tableData}
        columns={columns}
        title="Zone-Based Anomaly"
        emptyTitle="Empty"
        emptyDescription={""}
      />
    </Flex>
  );
}
